import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import Table from "react-bootstrap/Table";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "jspdf-autotable";
import md5 from "md5";
// import { downloadPdf } from "../../../services/utilities/util";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import SearchDateBox from "../../SearchDateBox";
import SearchDateBoxAsset from "../../SearchDateBoxAsset";
import domtoimage from "dom-to-image-more";
import { JsonToExcel } from "react-json-to-excel";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class BenchmarkProjects extends React.Component {
  static contextType = FilterContext;

  state = {
    mode: "yearly",
    modeText: "Switch To Quarterly",
    gradeText: "Switch To All Grade",
    grade: "AA+",
    area: "chargeable_area",
    areaText: "Switch To Carpet Area",
    start_date: "",
    end_date: "",
    which_date: "",
    which_date_name: "",
    benchmarkProjects: [],
    filters: "",
    showLoader: false,
    showGraph: false,
    tHead: [],
    complexNames: [],
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.setState({ filters: filters });
    apiMiddleware
      .post(
        "api/edge/office/get_benchmark_project_rents",
        BodyAsFormData(filters)
      )
      .then((res) => {
        const newHeader = ["Year/Quarter"];
        let excelData = [];
        res.data.complex.forEach((complex) => {
          ["Market rent", "Passing rent", "Effective rent"].forEach(
            (rentType) => {
              newHeader.push(`${complex} ${rentType}`);
            }
          );
        });
        res.data.data.forEach((x, j) => {
          let row = [];
          for (let i = 0; i < newHeader.length; i++) {
            row[newHeader[i]] = x[i] == "-" || i == 0 ? x[i] : Number(x[i]);
          }
          excelData.push(row);
        });
        console.log(excelData);
        this.setState({ showLoader: false, showGraph: true });
        this.setState({
          benchmarkProjects: res.data.data,
          tHead: res.data.data_header,
          complexNames: res.data.complex,
          excelData: excelData,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      var body = new FormData();
      body.append("filter", JSON.stringify(this.props.filters));
      if (
        this.state.end_date.length > 0 &&
        this.state.end_date != "ull" &&
        this.state.start_date.length > 0 &&
        this.state.start_date != "ull" &&
        this.state.which_date.length > 0
      ) {
        body.append("end_date", this.state.end_date);
        body.append("start_date", this.state.start_date);
        body.append("which_date", this.state.which_date);
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("grade", this.state.grade);
        body.append("mode", this.state.mode);
        body.append("area_type", this.state.area);
      } else if (typeof this.props.bodyParams != "undefined") {
        body = this.props.bodyParams;
      }
      this.setState({
        bodyParams: body,
      });
      // consol
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });

      apiMiddleware
        .post("api/edge/office/get_benchmark_project_rents", body)
        .then((res) => {
          const newHeader = ["Year/Quarter"];
          let excelData = [];
          res.data.complex.forEach((complex) => {
            ["Market rent", "Passing rent", "Effective rent"].forEach(
              (rentType) => {
                newHeader.push(`${complex} ${rentType}`);
              }
            );
          });
          res.data.data.forEach((x, j) => {
            let row = [];
            for (let i = 0; i < newHeader.length; i++) {
              row[newHeader[i]] = x[i] == "-" || i == 0 ? x[i] : Number(x[i]);
            }
            excelData.push(row);
          });
          console.log(excelData);
          this.setState({ showLoader: false, showGraph: true });
          this.setState({
            benchmarkProjects: res.data.data,
            tHead: res.data.data_header,
            complexNames: res.data.complex,
            excelData: excelData,
          });
        });
    }
  }

  dateFilter = (dateValue) => {
    this.setState({
      start_date: dateValue.startDate,
      end_date: dateValue.endDate,
      which_date: dateValue.dateType,
      which_date_name: dateValue.dateTypeName,
      filters: "",
      isOpen: false,
    });
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => this.setState({ isOpen: false });

  getModeData() {
    if (this.state.mode == "yearly") {
      this.setState({ mode: "quarterly" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        body.append("area_type", this.state.area);
        apiMiddleware
          .post("api/edge/office/get_benchmark_project_rents", body)
          .then((res) => {
            const newHeader = ["Year/Quarter"];
            let excelData = [];
            res.data.complex.forEach((complex) => {
              ["Market rent", "Passing rent", "Effective rent"].forEach(
                (rentType) => {
                  newHeader.push(`${complex} ${rentType}`);
                }
              );
            });
            res.data.data.forEach((x, j) => {
              let row = [];
              for (let i = 0; i < newHeader.length; i++) {
                row[newHeader[i]] = x[i] == "-" || i == 0 ? x[i] : Number(x[i]);
              }
              excelData.push(row);
            });
            console.log(excelData);
            this.setState({ showLoader: false, showGraph: true });
            this.setState({
              benchmarkProjects: res.data.data,
              tHead: res.data.data_header,
              complexNames: res.data.complex,
              excelData: excelData,
            });
          });
      });
    } else if (this.state.mode == "quarterly") {
      this.setState({ mode: "yearly" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        body.append("area_type", this.state.area);
        apiMiddleware
          .post("api/edge/office/get_benchmark_project_rents", body)
          .then((res) => {
            const newHeader = ["Year/Quarter"];
            let excelData = [];
            res.data.complex.forEach((complex) => {
              ["Market rent", "Passing rent", "Effective rent"].forEach(
                (rentType) => {
                  newHeader.push(`${complex} ${rentType}`);
                }
              );
            });
            res.data.data.forEach((x, j) => {
              let row = [];
              for (let i = 0; i < newHeader.length; i++) {
                row[newHeader[i]] = x[i] == "-" || i == 0 ? x[i] : Number(x[i]);
              }
              excelData.push(row);
            });
            console.log(excelData);
            this.setState({ showLoader: false, showGraph: true });
            this.setState({
              benchmarkProjects: res.data.data,
              tHead: res.data.data_header,
              complexNames: res.data.complex,
              excelData: excelData,
            });
          });
      });
    }

    if (this.state.modeText == "Switch To Quarterly") {
      this.setState({ modeText: "Switch To Yearly" });
    } else if (this.state.modeText == "Switch To Yearly") {
      this.setState({ modeText: "Switch To Quarterly" });
    }
  }

  getGradeWiseData() {
    if (this.state.grade == "All") {
      this.setState({ grade: "AA+" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("grade", this.state.grade);
        body.append("mode", this.state.mode);
        body.append("area_type", this.state.area);
        apiMiddleware
          .post("api/edge/office/get_benchmark_project_rents", body)
          .then((res) => {
            const newHeader = ["Year/Quarter"];
            let excelData = [];
            res.data.complex.forEach((complex) => {
              ["Market rent", "Passing rent", "Effective rent"].forEach(
                (rentType) => {
                  newHeader.push(`${complex} ${rentType}`);
                }
              );
            });
            res.data.data.forEach((x, j) => {
              let row = [];
              for (let i = 0; i < newHeader.length; i++) {
                row[newHeader[i]] = x[i] == "-" || i == 0 ? x[i] : Number(x[i]);
              }
              excelData.push(row);
            });
            console.log(excelData);
            this.setState({ showLoader: false, showGraph: true });
            this.setState({
              benchmarkProjects: res.data.data,
              tHead: res.data.data_header,
              complexNames: res.data.complex,
              excelData: excelData,
            });
          });
      });
    } else if (this.state.grade == "AA+") {
      this.setState({ grade: "All" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("grade", this.state.grade);
        body.append("mode", this.state.mode);
        body.append("area_type", this.state.area);
        apiMiddleware
          .post("api/edge/office/get_benchmark_project_rents", body)
          .then((res) => {
            const newHeader = ["Year/Quarter"];
            let excelData = [];
            res.data.complex.forEach((complex) => {
              ["Market rent", "Passing rent", "Effective rent"].forEach(
                (rentType) => {
                  newHeader.push(`${complex} ${rentType}`);
                }
              );
            });
            res.data.data.forEach((x, j) => {
              let row = [];
              for (let i = 0; i < newHeader.length; i++) {
                row[newHeader[i]] = x[i] == "-" || i == 0 ? x[i] : Number(x[i]);
              }
              excelData.push(row);
            });
            console.log(excelData);
            this.setState({ showLoader: false, showGraph: true });
            this.setState({
              benchmarkProjects: res.data.data,
              tHead: res.data.data_header,
              complexNames: res.data.complex,
              excelData: excelData,
            });
          });
      });
    }

    if (this.state.gradeText == "Switch To All Grade") {
      this.setState({ gradeText: "Switch To AA+" });
    } else if (this.state.gradeText == "Switch To AA+") {
      this.setState({ gradeText: "Switch To All Grade" });
    }
  }

  getAreaWiseData() {
    if (this.state.area == "carpetarea") {
      this.setState({ area: "chargeable_area" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("area_type", this.state.area);
        body.append("grade", this.state.grade);
        body.append("mode", this.state.mode);
        apiMiddleware
          .post("api/edge/office/get_benchmark_project_rents", body)
          .then((res) => {
            const newHeader = ["Year/Quarter"];
            let excelData = [];
            res.data.complex.forEach((complex) => {
              ["Market rent", "Passing rent", "Effective rent"].forEach(
                (rentType) => {
                  newHeader.push(`${complex} ${rentType}`);
                }
              );
            });
            res.data.data.forEach((x, j) => {
              let row = [];
              for (let i = 0; i < newHeader.length; i++) {
                row[newHeader[i]] = x[i] == "-" || i == 0 ? x[i] : Number(x[i]);
              }
              excelData.push(row);
            });
            console.log(excelData);
            this.setState({ showLoader: false, showGraph: true });
            this.setState({
              benchmarkProjects: res.data.data,
              tHead: res.data.data_header,
              complexNames: res.data.complex,
              excelData: excelData,
            });
          });
      });
    } else if (this.state.area == "chargeable_area") {
      this.setState({ area: "carpetarea" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("area_type", this.state.area);
        body.append("grade", this.state.grade);
        body.append("mode", this.state.mode);
        apiMiddleware
          .post("api/edge/office/get_benchmark_project_rents", body)
          .then((res) => {
            const newHeader = ["Year/Quarter"];
            let excelData = [];
            res.data.complex.forEach((complex) => {
              ["Market rent", "Passing rent", "Effective rent"].forEach(
                (rentType) => {
                  newHeader.push(`${complex} ${rentType}`);
                }
              );
            });
            res.data.data.forEach((x, j) => {
              let row = [];
              for (let i = 0; i < newHeader.length; i++) {
                row[newHeader[i]] = x[i] == "-" || i == 0 ? x[i] : Number(x[i]);
              }
              excelData.push(row);
            });
            console.log(excelData);
            this.setState({ showLoader: false, showGraph: true });
            this.setState({
              benchmarkProjects: res.data.data,
              tHead: res.data.data_header,
              complexNames: res.data.complex,
              excelData: excelData,
            });
          });
      });
    }

    if (this.state.areaText == "Switch To Chargeable Area") {
      this.setState({ areaText: "Switch To Carpet Area" });
    } else if (this.state.areaText == "Switch To Carpet Area") {
      this.setState({ areaText: "Switch To Chargeable Area" });
    }
  }

  downloadPdf() {
    const input = document.getElementById("benchmarkProjects1");
    // var element = document.getElementById('stackplanprintdiv');
    let scale = 2;
    let width = input.scrollWidth + 1500;
    let height = input.scrollHeight + 500;
    // if (width > height) {
    //   height = width + 200;
    // }
    width = width * scale;
    height = height * scale;
    domtoimage
      .toPng(input, {
        width: width,
        height: height,
        style: {
          transform: "scale(" + scale + ")",
          transformOrigin: "top left",
        },
      })
      .then(function (blob) {
        var pdf = new jsPDF("l", "px", [width, height]);
        pdf.addImage(blob, "PNG", 0, 0, width, height);
        pdf.save("benchmarkProjects" + ".pdf");
      });
    // html2canvas(input).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/png");
    //   const pdf = new jsPDF();
    //   const imgProps = pdf.getImageProperties(imgData);
    //   const pdfWidth = pdf.internal.pageSize.getWidth();
    //   const pdfHight = (imgProps.height * pdfWidth) / imgProps.width;
    //   pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHight);
    //   pdf.save("benchmarkProjects1.pdf");
    // });
  }

  render() {
    const data = {};
    data.startDate = this.state.start_date;
    data.endDate = this.state.end_date;
    data.dateType = this.state.which_date;
    data.dateTypeName = this.state.which_date_name;
    return (
      <div className="widget widgetTable">
        {this.state.showLoader && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/edgeLoader.gif" />
            </div>
          </div>
        )}
        {this.state.showGraph && (
          <>
            <div className="row">
              <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                <p>Benchmark Projects (₹/sqft/month)</p>
              </div>
              <div className="col-lg-3 text-end">
                <p className="colorBlack downloads">
                  <FontAwesomeIcon icon={faEllipsisV} />
                  <ul className="downloadOptions">
                    <li
                      className="excelDownload"
                      onClick={(e) => {
                        let body = new FormData();
                        body.append("path", window.location.pathname);
                        body.append("action", "excel_export");
                        body.append("count", 1);
                        body.append(
                          "hash",
                          window.location.search.split("?").pop()
                        );
                        body.append("screen_sub_type", "Benchmark Projects");
                        apiMiddleware
                          .post(process.env.REACT_APP_USER_ACTIVITY, body)
                          .then((res) => {
                            console.log(res);
                          });
                      }}
                    >
                      <JsonToExcel
                        title="Download as Excel"
                        data={this.state.excelData}
                        fileName="KeyProjects"
                        btnClassName="download-table-xls-button"
                      />
                      {/* <ReactHTMLTableToExcel
                        id="benchmarkProjectsTableXlsButton"
                        className="download-table-xls-button"
                        table="benchmarkProjects"
                        filename="benchmarkProjects"
                        sheet="benchmarkProjects"
                        buttonText={"Download as Excel"}
                      /> */}
                    </li>
                    {/* <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.downloadPdf();
                      }}
                    >
                      <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                    </li> */}
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.openModal();
                      }}
                    >
                      Select Date Range
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.getModeData();
                      }}
                    >
                      {this.state.modeText}
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.getGradeWiseData();
                      }}
                    >
                      {this.state.gradeText}
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.getAreaWiseData();
                      }}
                    >
                      {this.state.areaText}
                    </li>
                  </ul>
                </p>
              </div>
              <div className="col-lg-12 mt-2" id="benchmarkProjects1">
                <Table
                  className="assetMarketAnalysis benchmarkProjects"
                  responsive
                  hover
                  id="benchmarkProjects"
                >
                  <thead>
                    <tr>
                      <td></td>
                      {this.state.complexNames.map((row, i) => (
                        <td
                          colSpan={"3"}
                          className="text-center thBorderBottom"
                        >
                          {row}
                        </td>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {this.state.tHead.map((row, i) => (
                        <td className="text-end">{row}</td>
                      ))}
                    </tr>
                    {this.state.benchmarkProjects.map((row, i) => (
                      <tr className="">
                        {Object.values(row).map((val) => (
                          <td className="text-end">{val}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 chartSearchBox">
                <Modal
                  show={this.state.isOpen}
                  onHide={this.closeModal}
                  className="columnsModal selectColumn downloadImgModal chartModal"
                  size="lg"
                >
                  <Modal.Body>
                    <SearchDateBoxAsset
                      datechildFilter={this.dateFilter}
                      parentData={data}
                    />
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(BenchmarkProjects);
